import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AdministrationService } from './api/administration.service';
import { B2BPortalService } from './api/b2BPortal.service';
import { CompanyService } from './api/company.service';
import { CompanyCompanyProfileService } from './api/companyCompanyProfile.service';
import { CompanyProfileV3Service } from './api/companyProfileV3.service';
import { GlobalService } from './api/global.service';
import { InternalProductNameService } from './api/internalProductName.service';
import { MiscellaneousService } from './api/miscellaneous.service';
import { OfferService } from './api/offer.service';
import { PaymentService } from './api/payment.service';
import { ResellerService } from './api/reseller.service';
import { StellenanzeigenServicesService } from './api/stellenanzeigenServices.service';
import { SynchronizationService } from './api/synchronization.service';
import { UserService } from './api/user.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
